import { render, staticRenderFns } from "./mulitHelpActivityModal.vue?vue&type=template&id=2cb89ac2&scoped=true"
import script from "./mulitHelpActivityModal.vue?vue&type=script&lang=js"
export * from "./mulitHelpActivityModal.vue?vue&type=script&lang=js"
import style0 from "./mulitHelpActivityModal.vue?vue&type=style&index=0&id=2cb89ac2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb89ac2",
  null
  
)

export default component.exports